export const InterHeaderStyles =
  ' font-inter font-medium break-words text-sm truncate';

export const InterContentStyles =
  ' font-inter text-xs text-neutral-b1 font-normal leading-[18px] break-words truncate';
